export const tests = `
query tests ($filter: TestsFilter, $limit: Int, $nextToken: String) {
    tests (filter: $filter, limit: $limit, nextToken: $nextToken) {
        items {
            id
            createdAt
            updatedAt
            type
            name
            description
            summary
            asset {
                id
                createdAt
                updatedAt
                type
                thumbnailUri
                fileUri
            }
        }
        nextToken
        scannedCount
    }
}
`;

export const test = `query test ($id: String!) {
    test (id: $id) {
        id
        createdAt
        updatedAt
        questions {
            id
            createdAt
            updatedAt
            name
            correctAsset {
                id
                createdAt
                updatedAt
                type
                thumbnailUri
                fileUri
            }
            asset {
                id
                createdAt
                updatedAt
                type
                thumbnailUri
                fileUri
            }
            choices
            programType
            keywords
            summary
            description
            text
        }
        type
        name
        description
        summary
        asset {
            id
            createdAt
            updatedAt
            type
            thumbnailUri
            fileUri
        }
    }
}
`;
